<template>
  <div class="common-race">
    <IndexPc v-bind="props" />
  </div>
</template>
<script lang="ts" setup>
import IndexPc from './index-pc.vue'
import type { Character } from '~/api/interface/character'
interface CommonScenariosProps {
  digitalHumanList?: Character[]
}

const props = defineProps<CommonScenariosProps>()
</script>
<style lang="scss" scoped>
.common-race {
  @apply w-[1200px] mx-auto mt-[50px];

  @media (max-width: 680px) {
    width: vw(339);
  }
}
</style>
